<template>
  <span>
    <button
      class="text-button text-button--link-style"
      data-test-id="verify-via-text-message-button"
      @click="$store.dispatch('setAuthStep', { authStep: 'requestVerificationText' })"
    >
      verify via text message
    </button>.
  </span>
</template>

<script>
export default {
  name: 'VerifyViaTextMessageButton',
};
</script>
